import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core/styles";
import algoliasearch from "algoliasearch";
import React from "react";
import { Configure, InstantSearch, Pagination } from "react-instantsearch-dom";
import { connect } from "react-redux";

import Hits from "../../Search/Hits";
import SearchBox from "../../Search/SearchBox";
import ShiftTemplateHit from "../../Search/ShiftTemplateHit";
import config from "../../../config";

import "instantsearch.css/themes/algolia.css";

const ShiftTemplatePicker = ({
  open,
  onClose,
  onTemplateClick,
  serviceProviderId,
  templatesById,
}) => {
  const handleTemplateClick = (templateId) => {
    const template = templatesById[templateId];
    if (template !== undefined) {
      onTemplateClick(template);
    }
  };
  const classes = useStyles();
  return (
    <InstantSearch
      searchClient={algoliaClient}
      indexName={config.algolia.indecies.shiftTemplates}
      refresh={open}
    >
      <Configure
        attributesToSnippet={["note"]}
        filters={`serviceProviderId:${serviceProviderId}`}
      />
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <SearchBox
          className={classes.searchBox}
          placeholder="Search templates"
        />
        <DialogContent className={classes.hitsContainer}>
          <Hits
            className={classes.hits}
            hitComponent={({ hit }) => (
              <ShiftTemplateHit hit={hit} onClick={handleTemplateClick} />
            )}
          />
          <Pagination />
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={onClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </InstantSearch>
  );
};

const algoliaClient = algoliasearch(
  "2QYQC6POHC",
  "b92a1812cca73b7b072484abdfaa27ab"
);

const useStyles = makeStyles((theme) => ({
  searchBox: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  hitsContainer: {
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1),
  },
  hits: {
    paddingBottom: theme.spacing(1),
  },
}));

const mapStateToProps = (state) => ({
  serviceProviderId: state.auth.user.attributes["custom:service_provider_id"],
  templatesById: state.templates.byId,
});

export default connect(mapStateToProps)(ShiftTemplatePicker);
